import Head from "next/head"

import { siteConfig } from "@/config/site"

interface BrowserTabTitleProps {
  type: string
  name?: string
}

/**
 * Component to set a descriptive page title.
 * Usage:
 *   <BrowserTabTitle type="Run" name="abc123" />  // "Run > abc123 | Coval"
 *   <BrowserTabTitle type="Runs" />                // "Runs | Coval"
 *
 * The title will be formatted as "{type} > {name} | {siteConfig.name}" if name is provided,
 * or "{type} | {siteConfig.name}" if name is not provided.
 */
export const BrowserTabTitle = ({ type, name }: BrowserTabTitleProps) => {
  const fullTitle = name
    ? `${type} > ${name} | ${siteConfig.name}`
    : `${type} | ${siteConfig.name}`

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta key="og:title" content={fullTitle} property="og:title" />
    </Head>
  )
}
